import React from "react";
import { useInventoryTransfer } from "../../../../../hooks/inventory/useInventoryTransfer";
import FormModal from "../../../../Modals/FormModal";
import TransferInfoSection from "../TransferDetail/Sections/TransferInfoSection";
import TransferBranchesSection from "../TransferDetail/Sections/TransferBranchesSection";
import TransferFlowSection from "../TransferDetail/Sections/TransferFlowSection";
import AuditSection from "../TransferDetail/Sections/AuditSection";

const InventoryTransferConfirmModal: React.FC = () => {
  const {
    handlerConfirm,
    showConfirmModal,
    form,
    closeConfirmModal,
  } = useInventoryTransfer();

  if (!form) return null;

  const canConfirm =
    form.status === "APPROVED" || form.status === "APROVADO";

  return (
    <FormModal
      isOpen={showConfirmModal}
      onClose={closeConfirmModal}
      title="Confirmar Traslado"
      maxWidth="max-w-4xl"
      zIndex='front'
    >
      <div className="space-y-8 px-2 py-4">
        <TransferInfoSection
          details={form.details}
          reason={form.reason}
          status={form.status}
        />

        <TransferBranchesSection
          origin={form.originBranchName}
          destination={form.destinationBranchName}
        />

        <TransferFlowSection detail={form} />

        <AuditSection detail={form} />
      </div>

      {/* -------------------------------------------------------- */}
      {/* BOTONES DE ACCIÓN */}
      {/* -------------------------------------------------------- */}
      <div className="mt-6 flex justify-end gap-3">

        {/* Cerrar */}
        <button
          type="button"
          onClick={closeConfirmModal}
          className="inline-flex rounded bg-[#637381] px-6 py-2 text-sm font-medium text-white hover:bg-opacity-90"
        >
          Cerrar
        </button>

        {/* Confirmar */}
        {canConfirm && (
          <button
            type="button"
            onClick={() => handlerConfirm(form.id)}
            className="inline-flex rounded bg-primary px-6 py-2 text-sm font-medium text-white hover:bg-opacity-90"
          >
            Confirmar
          </button>
        )}
      </div>
    </FormModal>
  );
};

export default InventoryTransferConfirmModal;
